export const courseCategoryList = "COURSE_CATEGORY_LIST";
